export default __webpack_public_path__ + "static/media/Ganguly.1296d26c.png";